import { useCallback } from 'react';
import { Node } from 'reactflow';
import { pluralize, unmaskNumber } from '@givebutter/util';
import { faClock } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DelayNodeData } from 'assets/js/pages/engage/workflows/actions/types';
import * as NodeBadges from 'assets/js/pages/engage/workflows/components/NodeBadges';

interface DelayBadgeProps {
    delayNode: Node<DelayNodeData>;
}
const DelayBadge = ({ delayNode }: DelayBadgeProps) => {
    const values = delayNode.data.formData?.values;

    const DisplayValue = useCallback(() => {
        if (!values) return null;

        if (values.preset !== 'custom') {
            return <span className="text-gray-900">{`${values.preset} after`}</span>;
        }

        return (
            <span className="text-gray-900">
                {values.custom_value || 0}{' '}
                {pluralize(unmaskNumber(values.custom_value), values.custom_unit ?? '')} after{' '}
                <span className="text-gray-500">at</span>{' '}
                {values.custom_time ? values.custom_time.toFormat('h:mm a') : null}
            </span>
        );
    }, [values]);

    if (!values) return null;

    return (
        <NodeBadges.Badge className="flex flex-shrink-0 items-center gap-2">
            <FontAwesomeIcon icon={faClock} className="text-brand-violet-primary" />
            <p className="text-gray-500">
                Send <DisplayValue />
            </p>
        </NodeBadges.Badge>
    );
};

export { DelayBadge };
